/// <reference path="../../_ext/Editors/LaborGridEditor.ts" />
namespace TabAurous.Inventory {

    import fld = BranchOutLaborRow.Fields;

    @Serenity.Decorators.registerClass()
    export class BranchOutLaborEditor extends _Ext.LaborGridEditor<BranchOutLaborRow> {
         
        protected getDialogType() { return BranchOutLaborDialog; }
        protected getLocalTextPrefix() { return BranchOutLaborRow.localTextPrefix; }
        protected form: BranchOutLaborForm; 
        public PartyId: number;
        public LaborListId: number;
        public LaborMarkup: number;
        public ExchangeRate: number;
        public ItemAtbId: number; 
        private Item: BranchOutItemsRow; 

        constructor(container: JQuery) {
            super(container);
            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ forceFitColumns: true });

        }

        public setEditValue(source: BranchOutItemsRow, property) {

            super.setEditValue(source, property);
            //super.setOwnerEntity(source);
            this.Item = source;

        }
         
        private setATB() {
            var atbids = [];

            atbids.push(this.Item.AttributeId);

            this.Item.BOMDetails.forEach(function (x) {
                atbids.push(x.BOMAttributeId);

            });

            return atbids;
        }


        // #region Column Add -Remove
        protected getColumns() {

            var columns = super.getColumns();

            var num = ctx => ColumnFormatter.numericInputFormatter(ctx, this);
            var int = ctx => ColumnFormatter.integerInputFormatter(ctx, this);
            var str = ctx => ColumnFormatter.stringInputFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.LabourRate).format = num;
            Q.first(columns, x => x.field === fld.MarkUp).format = num;           


            //To Add Delete Button on Item Row
            columns.unshift({
                field: 'Delete Row',
                name: '',
                format: ctx => '<a class="inline-action delete-row" title="delete">' +
                    '<i class="fa fa-trash-o text-red"></i></a>',
                width: 24,
                minWidth: 24,
                maxWidth: 24
            });
            this.view.refresh();
            return columns;
        }

        // #endregion

        //#region Inline Editor
        //**** Delete event handler ****
        protected onClick(e: JQueryEventObject, row: number, cell: number) {
            super.onClick(e, row, cell);


            if (e.isDefaultPrevented())
                return;

            var item = this.itemAt(row);
            var target = $(e.target);

            // if user clicks "i" element, e.g. icon
            if (target.parent().hasClass('inline-action'))
                target = target.parent();

            if (target.hasClass('inline-action')) {
                e.preventDefault();

                if (target.hasClass('delete-row')) {
                    Q.confirm(' Are you sure want to delete? ', () => {
                        var id = this.id(item);
                        this.view.deleteItem(id);

                    });
                    this.view.refresh();
                }

                if (target.hasClass('edit numeric')) {
                    super.onClick(e, row, cell);
                }
            }
        }
 

        protected getButtons() {
            let buttons = super.getButtons();
            var grid = OMS.LabourMasterSelectGrid;

            //buttons.push({
            //    title: "Apply Labor Charges",
            //    cssClass: "add-button",
            //    onClick: () => {
            //        var atbs = this.setATB();
            //        OMS.LabourMasterSelectGrid.filter = atbs;
            //        var pickerDialog = new _Ext.GridItemPickerDialog({
            //            gridType: grid, multiple: true,
            //            preSelectedKeys: this.view.getItems().map(k => k.AttributeId && k.ProcessId)
            //        });

            //        pickerDialog.onSuccess = (selectedLabor: any[]) => {
            //            let filetredLabor = selectedLabor.filter(t => { return !Q.any(this.view.getItems(), n => n.ProcessId == t.ProcessId && n.AttributeId == t.AtbId) });
            //            var self = this;
            //            var BranchOutLaborDetails = [];
            //            filetredLabor.forEach(function (x) {
            //                var LAtbID = x.AttributeId;
            //                var LaborATBDetails =x;
            //                var LItemType = LaborATBDetails.ItemType;
            //                var LItemTypeID = LaborATBDetails.ItemTypeId;
            //                var LBaseItem = LaborATBDetails.ProductTypeName;
            //                var LBaseItemID = LaborATBDetails.ProductTypeId;
            //                var LAttribute = LaborATBDetails.Attribute;
            //                var LRate = x.SaleStdLabour;
            //                var LProcessID = x.ProcessId;
            //                var LProcess = OMS.ProcessMasterRow.getLookup().itemById[LProcessID];
            //                var LCalcName = OMS.FixedCodeRow.getLookup().itemById[LProcess.CalcOnId].FixedName;
            //                var CurrentItem = [];
            //                var CurrentPcs;
            //                var CurrentWt;
            //                var LAmount = 0;
            //                //if Current ATB is Not Product ATB get Weight and Pieces from BOM using ATB
            //                //ToDo: add multiple filters apart from ATBId
            //                if (LAtbID != self.Item.AttributeId) {

            //                    CurrentItem = self.Item.BOMDetails.filter(a => { return a.BOMAttributeId == LAtbID });
            //                    CurrentPcs = CurrentItem[0].Pieces;
            //                    CurrentWt = CurrentItem[0].Weight;
            //                }
            //                else {
            //                    CurrentPcs = self.Item.Pieces;
            //                    CurrentWt = self.Item.Weight;
            //                }
            //                //check if party has been assigned with LaborPriceList and get Values else use Std Rate
            //                if (self.LaborListId > 0) {

            //                    LRate = OMS.LabourPriceListDetailsRow.getLookup().items.filter(x => x.AttributeId == LAtbID && x.PriceListId == self.LaborListId).pop().Amount;
            //                    LAmount = LProcess.CalcOnId == 3 ? CurrentPcs * LRate : CurrentWt * LRate;
            //                }
            //                else {
            //                    LAmount = LProcess.CalcOnId == 3 ? CurrentPcs * LRate : CurrentWt * LRate;
            //                }

            //                var BranchOutLabor: BranchOutLaborRow = {
            //                    ItemTypeId: LItemTypeID,
            //                    ProductTypeName: LBaseItem,
            //                    ProductTypeId: LBaseItemID,
            //                    Attribute: LAttribute,
            //                    AttributeId: LAtbID,
            //                    ProcessId: LProcessID,
            //                    ProcessName: LProcess.ProcessName,
            //                    Pieces: CurrentPcs,
            //                    Weight: CurrentWt,
            //                    CalcOnId: LProcess.CalcOnId,
                               
            //                    LabourRate: LRate,
            //                    LabourAmount: LAmount
            //                }

            //                BranchOutLaborDetails.push(BranchOutLabor);
            //            });

            //            for (let LaborDetail of BranchOutLaborDetails) {
            //                LaborDetail[this.getIdProperty()] = "`" + this.nextId++;
            //                var x = LaborDetail;
            //                this.view.addItem(LaborDetail);
            //            }

            //        }

            //        pickerDialog.dialogOpen();
            //    }
            //});

            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);

            return buttons;
        } 
    }
}